import { apiClient } from './apiClient';

export interface FlussonicServer {
  id: string;
  name: string;
  baseUrl: string;
  username: string;
  enabled: boolean;
  notes?: string | null;
  createdDate?: string;
  updatedDate?: string;
}

export interface FlussonicStreamDetails {
  name: string | null;
  title: string | null;
  alive: boolean | null;
  running: boolean | null;
  clientCount: number | null;
  bytesIn: number | null;
  bytesOut: number | null;
  outBandwidth: number | null;
  inputErrorRate: number | null;
  retryCount: number | null;
  lastAccessAt: number | null;
}

export interface FlussonicServerDetails {
  id: string;
  name: string;
  baseUrl: string;
  enabled: boolean;
  streamCount: number;
  activeStreamCount: number;
  runningStreamCount: number;
  totalClients: number;
  totalBytesIn: number;
  totalBytesOut: number;
  totalOutBandwidth: number;
  streams: FlussonicStreamDetails[];
}

export interface FlussonicStreamOption {
  name: string;
  title: string | null;
  alive: boolean | null;
  running: boolean | null;
  clientCount: number | null;
}

interface FlussonicServerPayload {
  name: string;
  baseUrl: string;
  username: string;
  enabled: boolean;
  notes?: string;
}

export interface CreateFlussonicServerRequest extends FlussonicServerPayload {
  password: string;
}

export interface UpdateFlussonicServerRequest extends FlussonicServerPayload {
  id: string;
  password?: string;
}

export interface FlussonicServersResponse {
  success: boolean;
  servers: FlussonicServer[];
}

export interface FlussonicServerResponse {
  success: boolean;
  message?: string;
  server: FlussonicServer;
}

export const flussonicServerService = {
  async getServers(): Promise<FlussonicServersResponse> {
    return apiClient.get<FlussonicServersResponse>('/flussonic-servers');
  },

  async createServer(request: CreateFlussonicServerRequest): Promise<FlussonicServerResponse> {
    return apiClient.post<FlussonicServerResponse>('/flussonic-servers', request);
  },

  async updateServer(request: UpdateFlussonicServerRequest): Promise<FlussonicServerResponse> {
    return apiClient.put<FlussonicServerResponse>(`/flussonic-servers/${request.id}`, request);
  },

  async deleteServer(id: string): Promise<{ success: boolean; message: string }> {
    return apiClient.delete(`/flussonic-servers/${id}`);
  },

  async getServerDetails(id: string): Promise<FlussonicServerDetails> {
    return apiClient.get<FlussonicServerDetails>(`/flussonic-servers/${id}/details`);
  },

  async getServerStreams(id: string): Promise<{ success: boolean; streams: FlussonicStreamOption[] }> {
    return apiClient.get(`/flussonic-servers/${id}/streams`);
  },
};
